import { FormGroup } from "reactstrap";

interface Props {
  title?: string;
  description?: string;
  stateName?: string;
  value: boolean;
  checkedOption?: string;
  unCheckedOption?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerCSS?: string;
  disabled?: boolean;
  bannerOnDisabled?: boolean;
}

const CustomToggle = ({
  title,
  description,
  stateName,
  value,
  handleChange,
  containerCSS = "",
  disabled = false,
  checkedOption = "Yes",
  unCheckedOption = "No",
}: Props) => {
  return (
    <FormGroup className={containerCSS}>
      {title && <h4 className={!description ? "mb-3" : "mb-0"}>{title}</h4>}
      {description && (
        <div className="mb-3">
          <small>{description}</small>
        </div>
      )}
      <AppToggle
        stateName={stateName}
        value={value}
        checkedOption={checkedOption}
        unCheckedOption={unCheckedOption}
        handleChange={handleChange}
        disabled={disabled}
      />
    </FormGroup>
  );
};

export function AppToggle({
  stateName,
  value,
  handleChange,
  disabled = false,
  checkedOption,
  unCheckedOption,
}: Omit<Props, "title" | "description">) {
  return (
    <label className="custom-toggle">
      <input
        name={stateName}
        value={String(value)}
        type="checkbox"
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <span
        className="custom-toggle-slider rounded-circle"
        data-label-off={unCheckedOption}
        data-label-on={checkedOption}
      />
    </label>
  );
}

export default CustomToggle;
